<template>
    <div class="banner" :class="type">
        <div class="bannerleft"></div>
        <div class="bannerright" :style="`background-image:url(${returnImage()})`"></div>
        <div class="content fa_text">{{returnTitle()}}</div>
    </div>

</template>

<script>
    import imageOption from "@/mixins/imageOption";
    import util from "@/mixins/util";

    export default {
        name: "BannerLayout",
        mixins: [imageOption,],
        components: {},
        props: {
            infoData: {},
        },
        data() {
            return {
                type: ''
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.type = this.checkType()
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            checkType(){
                if(this.$route.name.includes("Intro")){
                    return "Intro"
                }
                else if(this.$route.name.includes("News")){
                    return 'News'
                }
                else if(this.$route.name.includes("Donate")){
                    return 'Donate'
                }
                else if(this.$route.name.includes("Amidan")){
                    return 'Amidan'
                }
                else if(this.$route.name.includes("Album")){
                    return 'Album'
                }
                else if(this.$route.name.includes("Term")){
                    return 'Term'
                }
                else if(this.$route.name.includes("Privacy")){
                    return 'Privacy'
                }
            },
            hasData() {
                return !util.isEmpty(this.infoData)
            },
            returnImage() {
                return `${this.infoData.org_url}?${this.setImageOptions(1286, 257, 'jpg')}`
            },
            returnTitle() {
                let type = this.type
                switch (type) {
                    case "Intro":
                        return '함께하는아버지들?'
                    case "News":
                        return '뉴스'
                    case "Donate":
                        return '나눔&배움'
                    case "Amidan":
                        return '아미단'
                    case "Album":
                        return '앨범'
                    case "Term":
                        return '서비스이용약관'
                    case "Privacy":
                        return '개인정보 처리방침'
                }
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>